import { render, staticRenderFns } from "./DeliveryNoteItems.vue?vue&type=template&id=4cd142c4&scoped=true"
import script from "./DeliveryNoteItems.vue?vue&type=script&lang=ts"
export * from "./DeliveryNoteItems.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryNoteItems.vue?vue&type=style&index=0&id=4cd142c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd142c4",
  null
  
)

export default component.exports